export default "__VITE_ASSET__rFIbyqjG__"